import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Login from '@/views/Login.vue'

export enum ROUTES {
    LOGIN = 'login',
    FANTAN_GAME = 'funtan-game',
    LOBY = 'loby'
}

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: ROUTES.LOBY,
        component: () => import('@/views/Loby.vue')
    },
    {
        path: `/${ROUTES.FANTAN_GAME}`,
        name: ROUTES.FANTAN_GAME,
        props: (_route) => ({
            deskNo: parseInt(String(_route.query.deskNo ?? -1))
        }),
        component: () => import('@/views/FantanGame.vue')
    },
    {
        path: `/${ROUTES.LOGIN}`,
        name: ROUTES.LOGIN,
        component: Login
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router
